import { useState, useEffect, useCallback } from 'react';
import { getProjectDebugDump } from '../../../../../api/api';

// Loads the raw DB rows for one PTS project (read-only debug view). Only
// fetches while `open`, and refetches on demand via refresh().
export default function useDbDebugV2(ptsProjectId, open) {
  const [dump, setDump] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const refresh = useCallback(() => {
    if (!ptsProjectId) return;
    setLoading(true);
    setError('');
    getProjectDebugDump(ptsProjectId)
      .then(r => setDump(r.data))
      .catch(e => setError(e?.response?.data?.error || e.message))
      .finally(() => setLoading(false));
  }, [ptsProjectId]);

  useEffect(() => { if (open) refresh(); }, [open, refresh]);

  return { dump, loading, error, refresh };
}
